import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { List } from 'immutable';
import { EventHttpService } from './event.http.service';
import { OnyxSummaryEvent } from '../models/event.summary';
import { Page } from '../../shared/models/page';
import { ErrorHandlerService } from '../../shared/utils/error-handler.service';
import { EventSearchParametersStore } from './event-search-parameters.store';

@Injectable()
export class EventListStore {

  private eventPage: BehaviorSubject<Page<OnyxSummaryEvent>> = new BehaviorSubject(Page.empty<OnyxSummaryEvent>());

  constructor(private eventHttpService: EventHttpService,
              private errorHandlerService: ErrorHandlerService,
              private searchParametersStore: EventSearchParametersStore) {
  }

  get events(): Observable<List<OnyxSummaryEvent>> {
    return this.eventPage.asObservable().map(page => page.content);
  }

  get totalEventCount(): Observable<number> {
    return this.eventPage.asObservable().map(page => page.totalElements);
  }

  get sortOptionsApplied(): Observable<Object> {
    return this.eventPage.asObservable().map(page => page.sort);
  }

  loadEvents(): Observable<Page<OnyxSummaryEvent>> {
    const obs = this.eventHttpService.search(this.searchParametersStore.eventSearchParametersSnapshot)
      .catch(this.errorHandlerService.handleObservable('Error retrieving events', 'Could not retrieve events!'))
      .map(page => {
        this.eventPage.next(page);
        return page;
      });
    return obs;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/service/event-list.store.ts